import React from "react";
import { Link } from "react-router-dom";
import styles from "../WelcomePage.module.css";

const LandingPromoterCard = ({
  promoterLabel,
  isLoading,
  registerHref,
  ctaText,
}) => {
  const Cta = registerHref.startsWith("http") ? (
    <a href={registerHref} className={styles.promoterCta} rel="noreferrer">
      {ctaText}
    </a>
  ) : (
    <Link
      to={registerHref}
      className={styles.promoterCta}
      state={{ mode: "registro", returnTo: "/apuestas" }}
    >
      {ctaText}
    </Link>
  );

  return (
    <section className={styles.promoterSection}>
      <div className={styles.promoterCard}>
        <div className={styles.promoterBadge}>Invitado por</div>
        <p className={styles.promoterCode}>{promoterLabel}</p>
        <p className={styles.promoterDesc}>
          {isLoading
            ? "Cargando campaña personalizada..."
            : "Regístrate con este enlace y mantén los beneficios de la campaña."}
        </p>
        {Cta}
      </div>
    </section>
  );
};

export default LandingPromoterCard;
